/* ===========================================================================
   Party Yachts Miami — collection page behaviour

   Filters are plain links built from Shopify's own url_to_add / url_to_remove,
   so narrowing the fleet works with JavaScript disabled and every combination
   has a real, shareable URL. This file only adds the conveniences:

     1. Open the filter panel by default on wide screens.
     2. Submit the sort dropdown on change.
     3. Load more, appending the next page instead of navigating away.
   =========================================================================== */
(function () {
  if (window.__pymCollectionInit) return;
  window.__pymCollectionInit = true;

  window.dataLayer = window.dataLayer || [];

  var root = document.querySelector('[data-pym-collection]');
  if (!root) return;

  /* ---------- Filter panel ---------- */

  var panel = root.querySelector('[data-pym-filters]');
  if (panel && window.matchMedia('(min-width: 990px)').matches) panel.open = true;

  /* ---------- Sort ---------- */

  var sort = root.querySelector('[data-pym-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.dataLayer.push({ event: 'collection_sort', sort_by: sort.value });
      window.location.href = url.toString();
    });
  }

  /* ---------- Load more ---------- */

  var btn = root.querySelector('[data-pym-load-more]');
  if (!btn) return;

  var grid = root.querySelector('[data-pym-grid]');
  var loading = false;

  btn.addEventListener('click', function () {
    if (loading) return;
    var next = btn.getAttribute('data-pym-load-more');
    if (!next) return;

    loading = true;
    var original = btn.textContent;
    btn.textContent = 'Loading...';
    btn.disabled = true;

    fetch(next)
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-pym-grid]');
        var nextBtn = doc.querySelector('[data-pym-load-more]');

        if (incoming) {
          Array.prototype.forEach.call(incoming.children, function (card) {
            grid.appendChild(document.importNode(card, true));
          });
        }

        var nextUrl = nextBtn ? nextBtn.getAttribute('data-pym-load-more') : '';
        if (nextUrl) {
          btn.setAttribute('data-pym-load-more', nextUrl);
          btn.textContent = original;
          btn.disabled = false;
        } else {
          btn.remove();
        }

        window.dataLayer.push({
          event: 'collection_load_more',
          shown: grid.children.length
        });
      })
      .catch(function () {
        // Fall back to a normal page load rather than leaving a dead button.
        window.location.href = next;
      })
      .finally(function () {
        loading = false;
      });
  });
})();
